import type { SourcePassengerCategory } from "@busbud/int-schemas";

export type Charges = PassengerCharge[][];
type PassengerCharge = {
  price_in_cents: number;
  category?: SourcePassengerCategory;
};

export interface RequiredChargeParams {
  amount: number;
  passenger: {
    category: SourcePassengerCategory;
  };
}

export interface GetPassengersChargeOptions {
  per_passenger?: boolean;
  direction?: "outbound" | "return";
}

const sumAllSegmentsPerPassenger = (
  charges_per_leg_and_segment: RequiredChargeParams[][][]
) => {
  return charges_per_leg_and_segment.map(leg_segments => {
    const leg_passengers: PassengerCharge[] = [];

    leg_segments.forEach((segment: RequiredChargeParams[]) => {
      segment.forEach((charge: RequiredChargeParams, pax_idx: number) => {
        if (!leg_passengers[pax_idx]) {
          leg_passengers[pax_idx] = {
            price_in_cents: 0,
            category: charge.passenger.category
          };
        }
        leg_passengers[pax_idx].price_in_cents += charge.amount;
      });
    });

    return leg_passengers;
  });
};

const sumAllSegments = (
  charges_per_leg_and_segment: RequiredChargeParams[][][]
) => {
  return charges_per_leg_and_segment.map(
    (leg_segments: RequiredChargeParams[][]) => {
      return [
        {
          price_in_cents: leg_segments.reduce(
            (total_segment: number, curr_segment: RequiredChargeParams[]) => {
              total_segment += curr_segment.reduce(
                (total, passenger) => (total += passenger.amount),
                0
              );
              return total_segment;
            },
            0
          )
        }
      ];
    }
  );
};

export const getPassengersCharge = (
  charges_per_leg_and_segment: RequiredChargeParams[][][],
  opts: GetPassengersChargeOptions = {}
): Charges => {
  let result: Charges;

  if (opts.per_passenger === false) {
    result = sumAllSegments(charges_per_leg_and_segment);
  } else {
    result = sumAllSegmentsPerPassenger(charges_per_leg_and_segment);
  }

  if (opts.direction) {
    const leg_idx = opts.direction === "outbound" ? 0 : "1";
    // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    result = [result[leg_idx]];
  }

  return result;
};
